import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Button, Spinner } from 'reactstrap';
// eslint-disable-next-line import/no-unresolved, import/extensions
import Icon from '../../../common/containers/icon';
const HeaderSection = _ref => {
  let _ref$summary = _ref.summary,
    summary = _ref$summary === void 0 ? {} : _ref$summary,
    _ref$isRunning = _ref.isRunning,
    isRunning = _ref$isRunning === void 0 ? false : _ref$isRunning,
    _ref$pendingOperation = _ref.pendingOperation,
    pendingOperation = _ref$pendingOperation === void 0 ? false : _ref$pendingOperation,
    onReRun = _ref.onReRun,
    onOpenSettings = _ref.onOpenSettings,
    formatTimestamp = _ref.formatTimestamp;
  return /*#__PURE__*/React.createElement(Row, {
    className: "mb-4 align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 8
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "mb-0"
  }, "Traceable. Reliable. Understandable."), /*#__PURE__*/React.createElement("div", {
    className: "text-muted"
  }, summary.timestamp && "Last Run: ".concat(formatTimestamp(summary.timestamp))))), /*#__PURE__*/React.createElement(Col, {
    lg: 4
  }, /*#__PURE__*/React.createElement("div", {
    className: "quality-agent__header-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    outline: true,
    onClick: onReRun,
    disabled: isRunning || pendingOperation,
    className: "quality-agent__action-button"
  }, isRunning ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "sm",
    className: "me-2"
  }), "Running...") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    glyph: "rotate-right",
    className: "quality-agent__icon-spacing"
  }), "Re-Run")), /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    outline: true,
    onClick: onOpenSettings,
    className: "quality-agent__action-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "gear",
    className: "quality-agent__icon-spacing"
  }), "Settings"))));
};
HeaderSection.propTypes = {
  summary: PropTypes.shape({
    timestamp: PropTypes.string
  }),
  isRunning: PropTypes.bool,
  pendingOperation: PropTypes.bool,
  onReRun: PropTypes.func.isRequired,
  onOpenSettings: PropTypes.func.isRequired,
  formatTimestamp: PropTypes.func.isRequired
};
export default HeaderSection;